<div
  class="project-list"
  unhObserveOffsetBottom
  [enabled]="true"
  [extraOffset]="100"
  (willEnterViewport)="onLoadmore()"
>
  <ng-container *ngIf="isNotFound$ | async">
    <unh-courses-not-found [@enterAnimation]></unh-courses-not-found>
  </ng-container>
  <ng-container *ngIf="(isNotFound$ | async) === false">
    <ng-container *ngFor="let project of projects; trackBy: trackByFn">
      <unh-card
        *ngIf="project.showInPublicListings"
        [@enterAnimationLeave]
        type="simple"
        [routerLink]="project.routerlink"
        [queryParamsHandling]="'preserve'"
        [tags]="project?.softwaretags"
        [backgroundCover]="project?.postthumbnail"
        [cardTitle]="project?.title"
        [backgroundThumbnail]="project?.postthumbnailcover"
        [name]="project?.creator?.alias"
        [profession]="project?.creator?.occupationtitle"
        [avatar]="project.creator.profilepicture"
        [backgroundHover]="true"
        [postLevel]="project?.levels"
        [postDuration]="project?.duration"
        [postLanguage]="project.audio?.langs"
        [postSubtitles]="project.subtitle?.langs"
        [ispro]="isCourse ? luss.subscribed :  luss.hasAccessToSpecialPosts"
        [isactive]="project?.product?.active"
        [isnew]="project?.isnew"
        [isAdminUser]="project.isAdminUser"
        [iscomingsoon]="project.iscommingsoon"
        [loading]="project?.title === 'loading'"
        [ismobile]="isMobile$ | async"
        [hasPromo]="hasPromo && (project?.hasPromo || _activePromo)"
        [productprice]="
          isCourse
            ? hasPromo && (project?.hasPromo || _activePromo)
              ? toNumber(project?.product?.pricewithdiscount) / 10
              : toNumber(project?.product?.price) / 10
            : anualPlan?.price
        "
        [cardLevelDescription]="
          this.pageTranslations?.cardArgsTranslation?.cardLevelDescription
        "
        [cardDurationDescription]="
          this.pageTranslations?.cardArgsTranslation?.cardDurationDescription
        "
        [cardAudioDescription]="
          this.pageTranslations?.cardArgsTranslation?.cardAudioDescription
        "
        [cardSubtitleDescription]="
          this.pageTranslations?.cardArgsTranslation?.cardSubtitleDescription
        "
        [coursesUnlockText]="
            this.pageTranslations?.cardArgsTranslation?.coursesNoPostion
        "
        [coursesUnlockMonth]="
          isCourse
            ? ''
            : this.pageTranslations?.cardArgsTranslation?.coursesUnlockMonth
        "
        [subscribersExclusive]="
          this.pageTranslations?.cardArgsTranslation?.subscribersExclusive
        "
        [haveAccessText]="
          this.pageTranslations?.cardArgsTranslation?.haveAccessText
        "
      >
        <unh-custom-promo-tag
          slot="promo_tag"
          *ngIf="
            (isMobile$ | async) === false && (project?.hasPromo || _activePromo)
          "
          [type]="'flag'"
          [plus]="true"
          [width]="119"
          [fontSize]="'38px'"
          [activePromo]="activePromo$ | async"
        ></unh-custom-promo-tag>

        <unh-custom-promo-tag
          slot="promo_tag"
          *ngIf="(isMobile$ | async) && (project?.hasPromo || _activePromo)"
          [type]="'flag'"
          [plus]="true"
          [width]="65"
          [fontSize]="'24px'"
          [activePromo]="activePromo$ | async"
        ></unh-custom-promo-tag>
      </unh-card>
      <!-- isMobile$ | async -->
    </ng-container>
  </ng-container>
</div>
